import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

/**
 * Blocks supplier portal until the platform agreement is accepted.
 * Redirects to /supplier/agreement until user.agreement_accepted == 1.
 */
export default function SupplierAgreementGate({ children }) {
  const { user } = useAuth();
  if (user?.role === 'supplier' && !user?.agreement_accepted) {
    return <Navigate to="/supplier/agreement" replace />;
  }
  return children;
}
